import { styled, Typography, TypographyProps } from '@mui/material';
import { UploadDetail } from '../../../../../services/entities/impl/blfApi/schemas/uploadSummary';
import { useUploadStatusLabel } from './hooks/useUploadStatusLabel';

const StyledStatusLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'status',
})<TypographyProps & { status: UploadDetail['status'] }>(
  ({ theme, status }) => ({
    color:
      status === 'Completed'
        ? theme.vars.palette.text.secondary
        : theme.vars.palette.text.primary,
  })
);

export const UploadStatusLabel = (props: {
  status: UploadDetail['status'];
}) => {
  const statusLabel = useUploadStatusLabel(props.status);
  return (
    <StyledStatusLabel variant='caption' {...props}>
      {statusLabel}
    </StyledStatusLabel>
  );
};
